import { render, staticRenderFns } from "./RainGame.vue?vue&type=template&id=d5421126&scoped=true&"
import script from "./RainGame.vue?vue&type=script&lang=js&"
export * from "./RainGame.vue?vue&type=script&lang=js&"
import style0 from "./RainGame.vue?vue&type=style&index=0&id=d5421126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5421126",
  null
  
)

export default component.exports